import React, { Component } from "react";
import { Route, Switch, Redirect, Router } from "react-router-dom";
import CoursePage from "../views/CoursePage";
import ModulePage from "../views/ModulePage";
import Notfound from "../views/Notfound";
import Login from "../views/auth/login";
import Home from "../views/Home";
import Dashboard from "../components/common/layout/Dashboard";
import ModuleManagement from "../views/dashboard/ModuleManagement";
import AddModule from "../views/dashboard/AddModule";
import UserManagement from "../views/dashboard/UserManagement";
import Profile from "../views/auth/profile";
import LandingPage from "../views/LandingPage";
import AdminDashboard from "../views/dashboard";
import EditCourse from "../views/dashboard/editCourse";
import EditModule from "../views/dashboard/EditModule";
import { decode as tokenDecoder } from "../utils/tokenDecoder";
import { PrivateRoute, ProtectedRoute, PublicRoute } from "./PrivateRoute";

export default class index extends Component {
  render() {
    const privateRoutes = [
      {
        path: "/dashboard",
        exact: true,
        component: { AdminDashboard },
      },
      {
        path: "/dashboard/courses/:courseName/module-management",
        exact: true,
        component: { ModuleManagement },
      },
      {
        path: "/dashboard/courses/:courseName/new-module",
        exact: true,
        component: { AddModule },
      },
      {
        path: "/dashboard/manage-users",
        exact: true,
        component: { UserManagement },
      },
    ];
    return (
      <Switch>
        <PublicRoute path={["/","/land" ]} exact component={LandingPage} />
        <PublicRoute path="/auth/login" exact component={Login} />
        <ProtectedRoute path="/home" exact component={Home} />
        <ProtectedRoute
          path="/courses/:courseName"
          exact
          component={CoursePage}
        />
        <ProtectedRoute
          path="/courses/:courseName/:moduleName"
          exact
          component={ModulePage}
        />
        <ProtectedRoute path="/account/settings" exact component={Profile} />
        <Route
          path={[
            "/dashboard",
            "/dashboard/courses/:courseName/module-management",
            "/dashboard/courses/:courseName/new-module",
            "/dashboard/manage-users",
            "/dashboard/courses/edit",
          ]}
        >
          <Dashboard>
            {/* component={({ match }) => ( */}
            <Switch>
              <PrivateRoute
                path="/dashboard"
                exact
                component={AdminDashboard}
              />
              <PrivateRoute
                path="/dashboard/courses/:courseName/module-management"
                exact
                component={ModuleManagement}
              />
              <PrivateRoute
                path="/dashboard/courses/edit"
                exact
                component={EditCourse}
              />
              <PrivateRoute
                path="/dashboard/courses/:courseName/new-module"
                exact
                component={AddModule}
              />
              <PrivateRoute
                path="/dashboard/courses/:courseName/edit-module"
                exact
                component={EditModule}
              />
              <PrivateRoute
                path="/dashboard/manage-users"
                exact
                component={UserManagement}
              />
            </Switch>
            {/* )} */}
          </Dashboard>
        </Route>
        <Route component={Notfound} />
      </Switch>
    );
  }
}
